"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var catalog_exports = {};
__export(catalog_exports, {
  Catalog: () => Catalog
});
module.exports = __toCommonJS(catalog_exports);
var Catalog;
((Catalog2) => {
  let Type;
  ((Type2) => {
    let EBundlePriceType;
    ((EBundlePriceType2) => {
      EBundlePriceType2[EBundlePriceType2["dynamic"] = 0] = "dynamic";
      EBundlePriceType2[EBundlePriceType2["static"] = 1] = "static";
    })(EBundlePriceType = Type2.EBundlePriceType || (Type2.EBundlePriceType = {}));
  })(Type = Catalog2.Type || (Catalog2.Type = {}));
  let Model;
  ((Model2) => {
    let Category;
    ((Category2) => {
      let Data;
      ((Data2) => {
        Data2.v1part = ["id", "name", "parent", "type", "store"];
        Data2.v2part = ["image", "products", "url", "short_description"];
      })(Data = Category2.Data || (Category2.Data = {}));
    })(Category = Model2.Category || (Model2.Category = {}));
    let Product;
    ((Product2) => {
      let Data;
      ((Data2) => {
        Data2.v1part = [
          "id",
          "url",
          "name",
          "sku",
          "status",
          "visibility",
          "catalog",
          "search",
          "image",
          "org_price",
          "price",
          "bundle_sp_perc",
          "tax",
          "is_from_price",
          "group_price",
          "group_org_price",
          "store",
          "type_id",
          "type"
        ];
        Data2.v2part = [
          "parent",
          "type_id",
          "reviews",
          "short_description",
          "news_from_date",
          "news_to_date",
          "isDivergent",
          "categories",
          "first",
          "last",
          "options",
          "price_type",
          "directChildrenIds",
          "indirectChildren",
          "stockMap",
          "listing_label",
          "variants"
        ];
      })(Data = Product2.Data || (Product2.Data = {}));
    })(Product = Model2.Product || (Model2.Product = {}));
  })(Model = Catalog2.Model || (Catalog2.Model = {}));
})(Catalog || (Catalog = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Catalog
});
